<template>
	<div class="profile-photo-ctrl">
		<svgicon icon="upload" class="profile-photo-ctrl__upload" @click="$refs.file.click();" />
		<div ref="preview" class="profile-photo-ctrl__preview" :style="this.url ? {backgroundImage: 'url(' + this.url + ')'} : {}"></div>
		<svgicon icon="trash" class="profile-photo-ctrl__trash" @click="remove" />
		<input @change="fileChange" class="profile-photo-ctrl__file" ref="file" type="file" />
	</div>
</template>

<script>
	export default {
		data: function () {
			return {
				removePhoto: false
			};
		},
		props: {
			url: String,
			name: String
		},
		methods: {
			fileChange(e) {
				var el = e.target;
				var ctrl = this;

				if (el.files && el.files[0]) {
					var reader = new FileReader();

					reader.onload = function (e) {
						ctrl.$refs.preview.style.backgroundImage = 'url(' + e.target.result + ')';
					}

					reader.readAsDataURL(el.files[0]);
					this.removePhoto = false;
				}
			},
			remove() {
				console.log('remove');
				this.removePhoto = true;
				this.$emit('remove');
			},
			update(endpoint, success) {
				var el = this.$refs.file;
				var onSuccess = success;

				if (this.removePhoto) {
					this.axios
						.delete(endpoint, formData)
						.then(function () {
							onSuccess();
						}, function () {
							onSuccess(); // 404
						});
				} else if (el.files && el.files[0]) {
					var formData = new FormData();
					formData.append(this.name, this.$refs.file.files[0]);

					this.axios
						.post(endpoint, formData, {
							headers: {
								'Content-Type': 'multipart/form-data'
							}
						})
						.then(function () {
							onSuccess();
						}, function () {
							console.log('error');
						});
				} else {
					onSuccess();
				}
			}
		},
		mounted() {

		}
	}
</script>

<style lang="scss">
	.profile-photo-ctrl {
		position: relative;
		height: 96px;
		text-align: center;

		&__upload, &__trash {
			fill: white;
			width: 24px;
			height: 24px;
			text-align: center;	
			cursor: pointer;
			position: absolute;
			top: 36px;
		}

		&__upload {
			left: 68px;
		}

		&__trash {
			right: 68px;
		}

		&__preview {
			width: 96px;
			height: 96px;
			background-color: blue;
			display: inline-block;
			background-size: cover;
			background-position: center center;
			border-radius: 50%;
		}

		&__file {
			display: none;
		}
	}
</style>